<template>
  <LoadingProgressBar />
  <div v-if="this.$route.path !== '/login' && this.$route.path !== '/'">
    <BottomNavigation />
  </div>

  <router-view />
  <CartBottomSheet v-model:visible="this.$cart.value" />
  <ContactUsPage v-model:visible="this.$contact.value" />
  <LoginModal :show="modalLogin" @click="modalLogin = false" />
</template>
<script>
import BottomNavigation from "@/components/BottomNavigation";
import LoadingProgressBar from "@/components/General/LoadingProgressBar";
import CartBottomSheet from "@/components/CartBottomSheet";
import LoginModal from "@/components/Modals/LoginModal";
import ContactUsPage from "./components/ContactUsPage.vue";

export default {
  name: "App",
  components: {
    LoadingProgressBar,
    BottomNavigation,
    CartBottomSheet,
    LoginModal,
    ContactUsPage,
  },
  // components: {
  //   LoginModal,
  //   CartBottomSheet,
  //   LoadingProgressBar,
  //   BottomNavigation,
  // },
  data() {
    return {
      modalLogin: this.$modalLogin,
    };
  },
};
</script>
<style>
.datepicker {
  display: flex;
  position: relative;
  height: 45px !important;
  border-bottom-left-radius: 10px !important;
  border-top-left-radius: 10px !important;
  width: 100px;
  color: #000;
}
@font-face {
  font-family: "iransans";
  src: url("assets/font/iran_sans.ttf");
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar {
  display: none;
}

html,
body {
  font-family: "iransans" !important;
  direction: rtl;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: #f3f4f6;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.animate-shimmer {
  mask: linear-gradient(-60deg, #000 30%, #0009, red 70%) right/300% 100%;
  animation: shimmer 3s infinite;
}

.vier-sheet-container {
  z-index: 20 !important;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

@keyframes shimmer {
  100% {
    -webkit-mask-position: left;
  }
}

.introjs-tooltiptext {
  font-family: "iransans";
  @apply text-sm;
}

.introjs-tooltipReferenceLayer * {
  font-family: "iransans";
  @apply text-sm;
}
</style>
